<template>
	<div class="generate-qr-form">
		<ModalHeader :title="getString('generate_qr_code')" />
		<div class="step-standard" v-if="currentStep === 0">
			<p class="explain-qr-choice">{{ getString('generate_qr_step_one_title') }}</p>
			<div class="choice-container">
				<div class="explain-choice">
					<div class="explain-choice-title">{{ getString('generate_qr_step_one_assigned_title') }}</div>
					<p class="explain-choice-side"><span class="title">{{ getString('upside') }}:</span> {{ getString('generate_qr_step_one_assigned_upside') }}</p>
					<p class="explain-choice-side"><span class="title">{{ getString('downside') }}:</span> {{ getString('generate_qr_step_one_assigned_downside') }}</p>
					<AppButton class="choice-action" outline :text="getString('assigned')" @click="selectChoice('per_table')" />
				</div>
				<div class="explain-choice">
					<div class="explain-choice-title">{{ getString('generate_qr_step_one_unique_title') }}</div>
					<p class="explain-choice-side"><span class="title">{{ getString('upside') }}:</span> {{ getString('generate_qr_step_one_unique_upside') }}</p>
					<p class="explain-choice-side"><span class="title">{{ getString('downside') }}:</span> {{ getString('generate_qr_step_one_unique_downside') }}</p>
					<AppButton class="choice-action" outline :text="getString('unique')" @click="currentStep = 1" />
				</div>
			</div>
			<div class="choice-actions-container">
				<div class="choice-title">{{ getString('generate_qr_step_one_actions') }}</div>
				<div class="choice-actions">
					<AppButton class="choice-action" outline :text="getString('assigned')" @click="selectChoice('per_table')" />
					<AppButton class="choice-action" outline :text="getString('unique')" @click="currentStep = 1" />
				</div>
			</div>
		</div>
		<div class="step-unique" v-else-if="currentStep === 1">
			<p class="explain-qr-choice">{{ getString('generate_qr_step_two_title') }}</p>
			<div class="choice-container">
				<div class="explain-choice">
					<div class="explain-choice-title">{{ getString('generate_qr_step_two_table_title') }}</div>
					<AppButton class="choice-action" outline :text="getString('table_number')" @click="selectChoice('table_number')" />
				</div>
				<div class="explain-choice">
					<div class="explain-choice-title">{{ getString('generate_qr_step_two_name_title') }}</div>
					<AppButton class="choice-action" outline :text="getString('customer_name')" @click="selectChoice('customer_name')" />
				</div>
			</div>
			<div class="choice-actions-container">
				<div class="choice-title">{{ getString('generate_qr_step_two_actions') }}</div>
				<div class="choice-actions">
					<AppButton class="choice-action" outline :text="getString('table_number')" @click="selectChoice('table_number')" />
					<AppButton class="choice-action" outline :text="getString('customer_name')" @click="selectChoice('customer_name')" />
				</div>
			</div>
		</div>
		<AppPopup
			:title="getString('confirm_choice_title')"
			:body-text="popupBody"
			:buttons="popupButtons"
			ref="confirm-choice"
		/>
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import AppButton from "@/shared/components/AppButton.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import {useUserStore} from "@/console-new/stores";
import API from "@/shared/helpers/API";

export default {
	setup() {
		let languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		return {getString: languageStore.getString, userStore, showNotification: notificationStore.showNotification}
	},
	name: "GenerateQrForm",
	components: {AppPopup, ModalHeader, AppButton},
	emits: ['chosen'],
	data() {
		return {
			currentStep: 0,
			choice: null,
			loadingConfirm: false
		}
	},
	props: {
		roomId: {
			type: Number,
			default: null
		}
	},
	computed: {
		popupBody() {
			if(this.choice === 'per_table') {
				return this.getString('confirm_choice_body_per_table');
			} else if(this.choice === 'table_number') {
				return this.getString('confirm_choice_body_table_number');
			} else if(this.choice === 'customer_name') {
				return this.getString('confirm_choice_body_customer_name');
			}
			return "";
		},
		popupButtons() {
			return [
				{text: this.getString('cancel'), negative: true},
				{text: this.getString('continue'), loading: this.loadingConfirm, callback: this.confirmChoice}
			]
		}
	},
	methods: {
		selectChoice(choice) {
			this.choice = choice;
			this.$refs['confirm-choice'].toggleStatus(true);
		},
		confirmChoice() {
			this.loadingConfirm = true;

			API.init().updateRoomType(this.userStore.currBusinessId, this.roomId, this.choice, (resp) => {
				this.loadingConfirm = false;
				this.$refs['confirm-choice'].toggleStatus(false);
				if(resp && resp.result && resp.result === "OK") {
					this.userStore.currBusiness.config_tables = true;
					this.$emit('chosen', this.choice);
					this.showNotification('generic-success');
				} else {
					this.showNotification('generic-fail');
				}
			});

		}
	}
}
</script>

<style scoped lang="scss">

.explain-qr-choice {
	margin: 20px 0;
	text-align: center;
	font-size: 16px;

}

.choice-container {
	display: flex;
	justify-content: space-around;
	flex-wrap: wrap;
	gap: 10px;

	.explain-choice {
		width: calc(50% - 10px);
		padding: 10px 15px;
		border-radius: 13px;
		background: var(--color-bg-primary-2);
		box-shadow: 0 2px 3px 0 rgba(7, 82, 163, 0.12);
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.explain-choice-title {
			font-size: 16px;
			text-align: left;
			margin-bottom: 15px;
		}

		.explain-choice-side {
			font-size: 14px;
			margin-bottom: 10px;

			.title {
				font-weight: bold;
			}
		}

		.choice-action {
			margin-top: 15px;
			margin-left: auto;
			margin-right: auto;
		}
	}

	@media(max-width: 500px) {
		flex-direction: column;

		.explain-choice {
			width: 100%;
		}

		.choice-action {
			display: none;
		}
	}
}

.choice-actions-container {
	margin-top: 20px;
	display: none;

	.choice-title {
		text-align: center;
	}

	@media(max-width: 500px) {
		display: flex;
		flex-direction: column;
	}

	.choice-actions {
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		gap: 10px;
		padding-bottom: 20px;

		@media(max-width: 500px) {
			display: flex;
			justify-content: space-around;
			margin-top: 20px;
		}
	}
}
</style>